{
    "ai-apps": {
        "tenantPromptMenu": "Tenant Prompt",
        "mcpServersMenu": "MCP Servers",
        "menu": "App Builder",
        "list": {
            "title": "Apps",
            "name": "App Name",
            "createApp": "Create new app",
            "deletedSuccessfully": "Application deleted successfully",
            "noAppsFound": "No applications found",
            "noPublishedVersion": "No published version",
            "publishedBy": "by {name}",
            "versionsCount": "• {count} versions",
            "updatedAt": "Updated {time}",
            "startApp": "Start app",
            "runPublishedVersion": "Run published version",
            "editApp": "Edit latest version",
            "continueEditingVersion": "Continue editing v{version}",
            "copyApp": "Copy app",
            "copyAppSubtitle": "Create a copy of this app",
            "deleteApp": "Delete app",
            "deleteAppSubtitle": "Permanently delete this app",
            "rowsPerPage": "Rows per page",
            "showAll": "All"
        },
        "nameAndDescription": "General",
        "buildTitle": "AI assistant",
        "dropSession": "Discard",
        "dropSessionConfirmation": "Are you sure that you want to delete current build session and discard all generated files and conversation?",
        "saveSession": "Save",
        "saveAndContinue": "Save and continue to build",
        "saveAndExit": "Save and exit Build Mode",
        "applySessionConfirmation": "Are you sure that you want to save current build session results?",
        "sessionConflict": "Another user is currently editing this version",
        "sessionConflictDetail": "Only one user can work on a version at a time. Please try again later.",
        "sessionConflictSuggestion": "You can select a different version or wait until the current session is completed.",
        "sessionStartError": "Failed to start build session",
        "applicationLabels": "Application labels",
        "labels": "labels",
        "undoLastPrompt": "Undo last prompt",
        "undoLastPromptFailed": "Failed to undo last prompt",
        "stopGenerating": "Stop generating",
        "stopGeneratingFailed": "Failed to stop generating",
        "cancelled": "Cancelled",
        "undone": "Undone",
        "labelsFilterSelected": "labels selected",
        "users": "Users",
        "usersFilterSelected": "users selected",
        "createdOrEditedBy": "Created or edited by",
        "description": "Description",
        "deleteConfirmation": "Are you sure that you want to delete following application: {name}",
        "copy": "Copy",
        "copyApplication": "Copy application",
        "copyOfName": "Copy of {name}",
        "copyFromVersion": "Copy from version",
        "applicationCopied": "Application copied successfully",
        "selectTables": "Tables",
        "name": "Name",
        "connection": "Connection",
        "vinceAi": "Vince AI",
        "usage": "Usage",
        "cost": "Cost",
        "tenantUsageTitle": "AI Apps usage",
        "applicationUsageTitle": "{name} usage",
        "versionUsageTitle": "Version {version} usage",
        "usageLoadError": "Usage could not be loaded.",
        "vinceAiMcpUnsupported": "Vince AI does not currently support MCP server resources. Select a tenant connection or remove the MCP servers.",
        "selectWorkflows": "Workflows",
        "summary": "Summary",
        "publishedColumn": "Published",
        "stateHeader": "Status",
        "createdBy": "Created by",
        "modifiedBy": "Modified by",
        "created": "Created by {name} on {date}",
        "newApplication": "Create new application",
        "customTablesSelected": "{selectedCount} custom tables selected.",
        "workflowsSelected": "{selectedCount} workflows selected.",
        "selectMcpServers": "MCP servers",
        "mcpServersSelected": "{selectedCount} MCP servers selected.",
        "summaryHeader": "Application summary",
        "resourceAliases": "Override resource aliases",
        "absentResource": "Resource not found",
        "customAlias": "Alias",
        "state": {
            "DRAFT": "Draft",
            "PUBLISHED": "Published",
            "ARCHIVED": "Archived"
        },
        "run": "Start",
        "currentVersion": "Version",
        "publishedVersionTooltip": "Published Version - by {name}",
        "createdVersions": "Created versions",
        "backToList": "Back to list",
        "back": "Back",
        "Version": "Version",
        "archive": "Archive",
        "publish": "Publish",
        "selectedVersion": "Selected version",
        "ver": "ver. ",
        "startBuildSession": "Build",
        "editVersionInfo": "Notes",
        "createNewVersion": "Create new version",
        "archiveVersion": "Archive",
        "resources": "Resources",
        "viewResources": "Resources",
        "versionResourcesLabel": "Resources for new version",
        "versionRolesLabel": "Roles for new version",
        "copyVersionRoles": "Copy roles from version {versionNumber}",
        "specifyNewRoles": "Create new roles",
        "specifyRolesAssignments": "Assign principals from scratch",
        "copyRolesAssignments": "Copy roles assignments from version {versionNumber}",
        "specifyNewResources": "Specify new resources",
        "versionAssets": "Assets for new version",
        "copyVersionResources": "Copy resources from version {versionNumber}",
        "copyVersionAssets": "Copy assets from version {versionNumber}",
        "generateFromScratch": "Generate from scratch",
        "resourcesNamesAreNotUnique": "Resource names must be unique",
        "editApplicationInfo": "Edit info",
        "publishVersion": "Publish",
        "updateVersionDescription": "Update description",
        "editVersionTitle": "Add note",
        "updateVersionNotes": "Update notes",
        "archiveVersionTitle": "Archive version",
        "publishVersionTitle": "Publish version",
        "setAsDraftVersionTitle": "Convert to draft",
        "newVersion": "New Version",
        "versionResources": "Resources available to application",
        "resourceNaming": "Resource names",
        "simpleM3Workflow": "Simple M3 Workflow",
        "resourcesUpdated": "Resources updated successfully",
        "changelog": "Versions history",
        "changelogTitle": "Application versions",
        "versionUpdated": "Version info updated",
        "versionCreated": "New version created successfully",
        "isFavourite": "Your favourite app. Click to unfavourite",
        "isNotFavourite": "Click to mark as favourite app",
        "copiedVersionDescription": "Description for new version",
        "messageSendFailed": "Failed to send message. Please try again.",
        "messageError": "Error",
        "waitingForResponse": "Waiting for response...",
        "typeYourMessage": "Describe what you want to build here...",
        "loadingConversation": "Loading conversation...",
        "loadingVersionInfo": "Loading version info...",
        "imageUploadFailed": "Failed to upload image: {filename}",
        "attachFiles": "Attach files ({allowed})",
        "dropFilesHere": "Drop files to attach",
        "removeAttachment": "Remove {name}",
        "removeFile": "Remove file",
        "attachmentsSummary": "{count} / {max} files (max {size} each)",
        "attachmentTypeNotAllowed": "File type of \"{name}\" is not allowed. Allowed types: {allowed}",
        "maxAttachmentsReached": "Maximum {max} files allowed per message",
        "attachmentEmpty": "File \"{name}\" is empty",
        "attachmentReadFailed": "File \"{name}\" could not be read",
        "attachmentTooLarge": "File \"{name}\" exceeds the {max} limit",
        "attachmentsTotalTooLarge": "Attachments exceed the {max} total limit per message",
        "attachmentContentMismatch": "File \"{name}\" does not match its file type. Allowed types: {allowed}",
        "clickBuildToBuild": "Click build to start building application...",
        "unsavedWorkAlert": "You have unsaved changes. Press Save to keep your progress.",
        "unsavedWorkLeaveMessage": "You have an active build session with unsaved work. If you leave, your progress will be lost. Are you sure you want to continue?",
        "providedAppsCanBeRunDirectly": "Provided apps can be run directly from the list.",
        "preview": {
            "appBridgeLogs": "Bridge log {logsCount}",
            "noPreviewAvailable": "No preview available",
            "askAiToGenerate": "Nothing to show yet, add a prompt to start building",
            "compilationFailed": "Compilation failed",
            "compiling": "Compiling...",
            "loading": "Loading preview...",
            "loadFailed": "Failed to load preview",
            "clearLogs": "Clear logs",
            "invocationLogs": "App bridge logs"
        },
        "invocationAction": {
            "REQUEST_RECEIVED": "Request from app: ",
            "RESPONSE_RETURNED": "Response to app ",
            "ERROR": "Error happened ",
            "INIT": "Bridge initialized"
        },
        "startingApplication": "Starting application. Please wait...",
        "providedSourceUrl": "Index url for provided app",
        "applicationType": {
            "GENERATED": "Generated",
            "PROVIDED": "Provided"
        },
        "applicationTypeLabel": "Application type",
        "minimize": "Minimize",
        "toggleFullScreen": "Fullscreen",
        "resource": {
            "app": "App",
            "mcpServer": "MCP Server",
            "tenantPrompt": "Tenant Prompt",
            "mcpToolPermission": "MCP tool permission"
        },
        "seconds": "s",
        "noMessagesYet": "No messages yet",
        "generatedAssets": "Generated assets",
        "assetsListTitle": "Assets list",
        "selectAsset": "Select asset to get details",
        "showAssets": "Assets",
        "noStartUrlProvided": "Cannot determine start url for application",
        "refresh": "Refresh",
        "cannotEditInfoOfAppWithBuildSession": "Cannot edit version information with active build session",
        "cannotShowOfAppWithBuildSession": "Cannot show assets with active build session - assets will be available after build session is completed",
        "cannotArchiveVersionWithBuildSession": "Cannot archive version with active build session. First apply or discard current build session",
        "cannotPublishVersionWithBuildSession": "Cannot publish version with active build session. First apply or discard current build session",
        "cannotEditResourcesWithBuildSession": "With active build session it is possible only to view resources",
        "cannotEditRolesWithBuildSession": "Cannot edit in-app roles with active build session. First apply or discard current build session",
        "tenantPrompt": {
            "title": "Tenant Prompt",
            "subtitle": "Prompt that will be automatically added as part of system prompt to all conversations with your AI assistant."
        },
        "principalType": {
            "USER": "User",
            "ROLE": "Role"
        },
        "selectUsers": "Select users",
        "assignments": "In-app role assignments: ",
        "simulateRoles": "Simulate Roles",
        "roleNotAssigned": "Role has no principals assigned",
        "addAssignments": "Add assignments",
        "rolesSelected": "{selectedCount} roles selected.",
        "usersSelected": "{selectedCount} users selected.",
        "selectRoles": "Select roles",
        "rolesMenu": "In-app Roles",
        "rolesListTitle": "Roles",
        "deleteRoleSuccess": "In-app role deleted successfully",
        "editRole": "Edit in-app role",
        "roleName": "Role name/identifier",
        "roleNameHint": "Try to use short and descriptive name",
        "dangerToChangeRole": "Changing role name/identifier can break existing application. Change if you are sure that application not using this role.",
        "deleteRoleConfirmation": "Are you absolutely sure that you want to delete role: {role}? All role assignments will be removed as well and parts of application can become unusable without it.",
        "selectRole": "Select role to see assignments",
        "selectSession": "Select build session to see prompt",
        "sessionsTitle": "Build sessions",
        "noBuildSessions": "No build sessions completed yet",
        "showBuildPrompt": "Build Prompt",
        "feedbackMenu": "Feedback",
        "feedbackTitle": "Application feedback",
        "showRead": "Show read",
        "thisVersionOnly": "This version only",
        "noFeedback": "No feedback yet",
        "markAsRead": "Mark as read",
        "feedbackMarkedRead": "Feedback marked as read",
        "read": "Read",
        "feedbackSubmitted": "By {name} on {date}",
        "feedbackComment": "Feedback",
        "feedbackBy": "Submitted by",
        "feedbackDate": "Date",
        "feedbackStatus": "Status",
        "mcpServers": {
            "title": "MCP Servers",
            "create": "Add MCP Server",
            "createTitle": "Add MCP Server",
            "editTitle": "Edit MCP Server",
            "name": "Name",
            "nameHint": "Machine identifier used as the connector name. Must match the allowed character set.",
            "namePatternError": "Name may only contain letters, digits, underscores and hyphens (1-128 characters).",
            "systemPrompt": "System prompt",
            "systemPromptHint": "Optional prompt fragment describing the server's tools to the app builder assistant.",
            "config": "Configuration template",
            "configHint": "JSONata/VinceLiveMorph template that must evaluate to an object: {props}. Example:",
            "configVariables": "Available variables (bare and under $context): $authToken, $userId, $email. JSONata variables are unquoted. url must be a non-empty string.",
            "noServersFound": "No MCP Servers configured yet",
            "deleteConfirmation": "Are you sure that you want to delete the MCP server: {name}?",
            "deleted": "MCP server deleted successfully",
            "created": "MCP server created successfully",
            "updated": "MCP server updated successfully",
            "testConnection": "Test connection",
            "probeReachable": "Server reachable",
            "probeNoTools": "Server reachable, no tools exposed",
            "probeFailed": "Connection failed"
        },
        "devicePicker": {
            "deleted": "Device deleted successfully",
            "DESKTOP": "Desktop",
            "TABLET": "Tablet",
            "HANDHELD": "Mobile",
            "addCustom": "Add custom",
            "customDefault": "Custom",
            "responsivePreview": "Responsive preview mode",
            "rotate": "Rotate viewport"
        },
        "serviceStatus": {
            "minor": "AI features may be slightly slower than usual.",
            "major": "AI features are currently disrupted — expect slow responses.",
            "critical": "AI service is currently unavailable."
        },
        "claudeStatus": {
            "tooltip": "Claude: {status}. Last checked: {time}. Click for details.",
            "notChecked": "not checked yet",
            "status": {
                "unknown": "Status unavailable",
                "operational": "Operational",
                "degraded": "Degraded performance",
                "partial_outage": "Partial outage",
                "major_outage": "Major outage",
                "maintenance": "Under maintenance"
            }
        }
    }
}
